import { defineStore } from 'pinia'
import { AircraftTypeService, IATAAirportService } from '@/services/api/iata.js'
import { AirlineService } from '@/services/api/airline.js'
import { handleApiError } from '@/services/errorHandler.js'

export const useIataStore = defineStore('iataStore', {
  state: () => ({
    aircraftTypes: [],
    aircraftTypesLoading: false,
    // Separate departure/arrival state to avoid conflicts when both dropdowns are active
    departureAirports: [],
    departureAirportsLoading: false,
    arrivalAirports: [],
    arrivalAirportsLoading: false,
    airlines: [],
    airlinesLoading: false,
  }),

  actions: {
    async searchAircraftTypes(query) {
      const q = (query ?? '').trim()
      if (!q) {
        this.aircraftTypes = []
        this.aircraftTypesLoading = false
        return
      }
      this.aircraftTypesLoading = true
      try {
        const { data } = await AircraftTypeService.list({ search: q })
        this.aircraftTypes = Array.isArray(data) ? data : (data?.results ?? [])
      } catch (e) {
        handleApiError(e, { title: 'Aircraft type search failed', silent: true })
        this.aircraftTypes = []
      } finally {
        this.aircraftTypesLoading = false
      }
    },

    async searchDepartureAirports(query) {
      const q = (query ?? '').trim()
      if (!q) {
        this.departureAirports = []
        this.departureAirportsLoading = false
        return
      }
      this.departureAirportsLoading = true
      try {
        const { data } = await IATAAirportService.list({ search: q })
        this.departureAirports = Array.isArray(data) ? data : (data?.results ?? [])
      } catch (e) {
        handleApiError(e, { title: 'Airport search failed', silent: true })
        this.departureAirports = []
      } finally {
        this.departureAirportsLoading = false
      }
    },

    async searchArrivalAirports(query) {
      const q = (query ?? '').trim()
      if (!q) {
        this.arrivalAirports = []
        this.arrivalAirportsLoading = false
        return
      }
      this.arrivalAirportsLoading = true
      try {
        const { data } = await IATAAirportService.list({ search: q })
        this.arrivalAirports = Array.isArray(data) ? data : (data?.results ?? [])
      } catch (e) {
        handleApiError(e, { title: 'Airport search failed', silent: true })
        this.arrivalAirports = []
      } finally {
        this.arrivalAirportsLoading = false
      }
    },

    async searchAirlines(query) {
      const q = (query ?? '').trim()
      if (!q) {
        this.airlines = []
        this.airlinesLoading = false
        return
      }
      this.airlinesLoading = true
      try {
        const { data } = await AirlineService.list({ search: q })
        this.airlines = Array.isArray(data) ? data : (data?.results ?? [])
      } catch (e) {
        handleApiError(e, { title: 'Airline search failed', silent: true })
        this.airlines = []
      } finally {
        this.airlinesLoading = false
      }
    },
  },
})
